import { Component, Input, OnInit } from '@angular/core';
import {
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-form-select',
  standalone: true,
  imports: [ReactiveFormsModule, NzSelectModule, NgClass],
  templateUrl: './form-select.component.html',
  styleUrl: './form-select.component.scss',
  host: {
    class: 'grid grid-cols-12',
  },
})
export class FormSelectComponent implements OnInit {
  @Input({ required: true }) label!: string;
  @Input({ required: true }) attribute!: string;
  @Input({ required: true }) valueKey!: number | string;
  @Input({ required: true }) labelKey!: string;
  @Input() readOnly = false;
  @Input() subformGroup: string | null = null;
  @Input({ required: true }) selectOptions!: any[];
  form!: FormGroup;
  currentForm!: FormGroup;

  constructor(private rootFormGroup: FormGroupDirective) {}

  ngOnInit() {
    this.form = this.rootFormGroup.control;

    if (this.subformGroup) {
      const group = this.form.get(this.subformGroup) as FormGroup;
      if (!group) {
        throw new Error(
          `SubFormGroup "${this.subformGroup}" does not exist in form`,
        );
      }
      this.currentForm = group;
    } else {
      this.currentForm = this.form;
    }
  }
}
